export const Top = () => {
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <button className="scroll-top scroll-to-target" data-target="html" onClick={handleScrollTop}>
      <span className="fa fa-arrow-up"></span>
    </button>
  );
};